(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oligosan-popup-newsletter"]) return;
  try {
    
  /**
   * Ouvre la fenetre une fois, au premier des deux signaux : le delai, ou la
   * part de page parcourue. Ensuite, c'est l'onglet lateral qui prend le
   * relais. Le choix du visiteur tient dans le stockage local ; s'il n'est
   * pas accessible, la fenetre ne s'ouvre pas d'elle-meme et l'onglet reste
   * disponible, ce qui est le comportement le moins intrusif.
   */
  class OligosanPopup extends HTMLElement {
    connectedCallback() {
      this.fenetre = this.querySelector('dialog');
      this.onglet = this.querySelector('[data-ouvrir]');
      if (!this.fenetre || !this.onglet) return;

      this.cle = this.dataset.cle;
      this.apercu = this.dataset.apercu === 'true';

      this.onglet.addEventListener('click', () => this.ouvrir());
      this.querySelector('[data-fermer]').addEventListener('click', () => this.fenetre.close());
      this.fenetre.addEventListener('close', () => this.marquer('ferme'));
      this.addEventListener('submit', () => this.marquer('inscrit'));

      // Un formulaire qui vient d'etre envoye rouvre la fenetre sur son message.
      if (this.querySelector('[role="status"], [role="alert"]')) {
        this.ouvrir();
        return;
      }

      const etat = this.lire();
      if (etat === 'inscrit' && !this.apercu) return;

      this.onglet.hidden = false;
      if (etat || this.apercu) return;
      this.armer();
    }

    /** Programme la premiere ouverture, au delai ou au defilement. */
    armer() {
      let fait = false;
      const declencher = () => {
        if (fait) return;
        fait = true;
        document.removeEventListener('scroll', auDefilement, { capture: true });
        this.ouvrir();
      };
      const auDefilement = () => {
        const e = this.conteneur();
        const h = e.scrollHeight - e.clientHeight;
        if (h > 0 && (e.scrollTop / h) * 100 >= Number(this.dataset.defilement)) declencher();
      };
      // En capture : le defilement d'un conteneur interne ne remonte pas.
      document.addEventListener('scroll', auDefilement, { passive: true, capture: true });
      setTimeout(declencher, Number(this.dataset.delai) * 1000);
    }

    /**
     * Le conteneur qui defile vraiment : au-dela de 990 px, Horizon fait
     * defiler `.page-wrapper` et non le document.
     */
    conteneur() {
      const p = document.querySelector('.page-wrapper');
      if (p && p.scrollHeight > p.clientHeight + 1) return p;
      return document.scrollingElement || document.documentElement;
    }

    ouvrir() {
      if (this.fenetre.open) return;
      this.fenetre.showModal();
      const champ = this.querySelector('input[type="email"]');
      if (champ) champ.focus();
    }

    lire() {
      try {
        return window.localStorage.getItem(this.cle);
      } catch (e) {
        return 'indisponible';
      }
    }

    marquer(valeur) {
      if (valeur === 'inscrit') this.onglet.hidden = true;
      try {
        window.localStorage.setItem(this.cle, valeur);
      } catch (e) {
        /* navigation privee ou stockage bloque : rien a faire */
      }
    }
  }

  if (!customElements.get('oligosan-popup')) {
    customElements.define('oligosan-popup', OligosanPopup);
  }

  } catch(e) { console.error(e); }
})();
})();
